import { translate } from '@components/i18n';
import { orderItemsSelector } from '@redux/slices/order';
import { formatMoney } from '@utils/money';
import { useSelector } from 'react-redux';
import Comparison from 'src/enums/comparison';

export const columns = [
    {
        title: translate('columns.solicitation'),
        dataIndex: 'id',
        sorter: false,
        width: '8%',
    },
    {
        title: translate('columns.clientCode'),
        dataIndex: 'codigoCliente',
        sorter: false,
        width: '15%',
    },
    {
        title: translate('columns.client'),
        dataIndex: 'nomeCliente',
        sorter: false,
        width: '15%',
    },
    {
        title: translate('columns.representerCode'),
        dataIndex: 'usuarioId',
        sorter: false,
        width: '15%',
    },
    {
        title: translate('columns.representer'),
        dataIndex: 'usuarioNome',
        sorter: false,
        width: '15%',
    },
    {
        title: translate('columns.division'),
        dataIndex: 'divisao',
        sorter: false,
        width: '15%',
    },
    {
        title: translate('columns.discount'),
        dataIndex: 'desconto',
        sorter: false,
        width: '15%',
        render: (text) => {
            return <span>{text}%</span>;
        },
    },
    {
        title: translate('columns.total'),
        dataIndex: 'total',
        sorter: false,
        width: '15%',
        render: (_, record) => {
            const {moedaSimbolos} = useSelector(orderItemsSelector)
            const moeda = moedaSimbolos.find(item => item.codigoMoeda === record?.codigoMoeda)

            return (
                <span>
                    {formatMoney(
                        moeda?.simbolo,
                        record.pedidos.reduce(
                            (acc, cur) => acc + cur.valorTotal,
                            0,
                        ),
                    )}
                </span>
            );
        },
    },
    {
        title: translate('columns.totalWithDiscount'),
        dataIndex: 'total',
        sorter: false,
        width: '15%',
        render: (_, record) => {
            return (
                <span>
                    {formatMoney(
                        undefined,
                        record.pedidos.reduce(
                            (acc, cur) => acc + cur.valorTotal,
                            0,
                        ) -
                            record.pedidos.reduce(
                                (acc, cur) => acc + cur.valorTotal,
                                0,
                            ) *
                                (record.desconto / 100),
                    )}
                </span>
            );
        },
    },
];

export const filterTypes = [
    {
        name: 'codigo',
        description: translate('filters.solicitation'),
        comparisonFilter: [
            Comparison.EQ,
            Comparison.NEQ,
            Comparison.GT,
            Comparison.LT,
        ],
    },
    {
        name: 'codigo_cliente',
        description: translate('filters.clientCod'),
        comparisonFilter: [
            Comparison.EQ,
            Comparison.NEQ,
            Comparison.GT,
            Comparison.LT,
        ],
    },
    {
        name: 'nome_cliente',
        description: translate('filters.clientName'),
        comparisonFilter: [
            Comparison.CONTAINS,
            Comparison.NOT_CONTAINS,
            Comparison.BEGINS_WITH,
            Comparison.EQ,
            Comparison.NEQ,
        ],
    },
    {
        name: 'divisao',
        description: translate('filters.division'),
        comparisonFilter: [Comparison.CONTAINS, Comparison.EQ, Comparison.NEQ],
    },
    {
        name: 'status',
        description: translate('filters.status'),
        comparisonFilter: [Comparison.EQ, Comparison.NEQ],
    },
    {
        name: 'data',
        description: translate('filters.date'),
        comparisonFilter: [
            Comparison.EQ,
            Comparison.NEQ,
            Comparison.GT,
            Comparison.LT,
        ],
    },
];
